import React, { useState } from "react";
import '../../components/ForgetPassword/ForgetPassword.css';
import { RxCross2 } from "react-icons/rx";
import { IoMdArrowBack } from "react-icons/io";
import ForgetEmail from "../ForgetEmail/ForgetEmail";
import { forgetPasswords } from "../../API/Api";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgetPassword = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState("");
    const [userType, setUserType] = useState("buyer");
    const [errors, setErrors] = useState({});
    const [isForgetEmailOpen, setIsForgetEmailOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    if (!isOpen) return null;

    const validateEmail = () => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email) {
            setErrors({ email: "Please enter your email address." });
            return false;
        }
        if (!emailPattern.test(email)) {
            setErrors({ email: "Please enter a valid email address." });
            return false;
        }
        setErrors({});
        return true;
    };

    const handleSubmitClick = async () => {
        if (!validateEmail()) return;
        
        setIsLoading(true);
        try {
            const response = await forgetPasswords(email, userType);
            
            if (response.status) {
                toast.success(response.message, {
                    position: "top-right",
                    autoClose: 3000,
                });
                setIsForgetEmailOpen(true);
            } else {
                if (response.message) {
                    toast.error(response.message, {
                        position: "top-right",
                        autoClose: 5000,
                    });
                }
            }
        } catch (error) {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                });
            } else if (error.message) {
                toast.error(error.message, {
                    position: "top-right",
                    autoClose: 5000,
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleCloseForgetEmail = () => {
        onClose();
        setIsForgetEmailOpen(false);
    };

    return (
        <div className="forgetModalOverlay">
            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
            />

            {!isForgetEmailOpen && isOpen && (
                <div className="forgetModal">
                    <div className="headerforget">
                        <div className="headerContent">
                            <h2 className="forgetTitle">Forgot Password</h2>
                            <button className="closeModalBtns" onClick={onClose}>
                                <RxCross2 />
                            </button>
                        </div>
                    </div>

                    <p className="forgetText">Enter your email address below and we will send you a link to reset your password.</p>
                    
                    <div className="inputGroups">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            className="loginInput"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                if (errors.email) setErrors({});
                            }}
                        />
                        {errors.email && <p className="errorText">{errors.email}</p>}
                    </div>

                    <button 
                        className="loginBtn" 
                        onClick={handleSubmitClick}
                        disabled={isLoading}
                    >
                        {isLoading ? "SENDING..." : "SUBMIT"}
                    </button>
                </div>
            )}

            {isForgetEmailOpen && (
                <ForgetEmail
                    isOpen={isForgetEmailOpen}
                    onClose={handleCloseForgetEmail}
                    email={email}
                    userType={userType}
                />
            )}
        </div>
    );
};

export default ForgetPassword;